<template>
    <div class="jobfair-list index-bar-list">
        <header>
            <swipe
                    :autoplay="3000"
                    style="height: 106px; background-color: #378EDE;"
                    indicator-color="#f00"
            >
                <swipe-item v-for="(image, index) in images" :key="index">
                    <div class="swipe-content" :style="'background-image: url(' + image + ')'"></div>
                </swipe-item>
            </swipe>
        </header>
        <index-bar>
            <index-anchor>
                <section>
                    <cell-group>
                        <field
                                v-model="jobfair_name"
                                placeholder="请输入双选会名称"
                                left-icon="search"
                                @click-left-icon="searchFn"
                        >
                            <van-button slot="button" size="small" type="info" @click="searchFn" plain>搜索</van-button>
                        </field>
                    </cell-group>
                </section>
            </index-anchor>
            <!-- <section>
            <wy-select :list="SelectList"></wy-select>
            </section>-->

            <section class="list">
                <pull-refresh v-model="list.refreshLoading" @refresh="onRefresh">
                    <list
                            v-model="list.loading"
                            :finished="list.finished"
                            :error.sync="list.error"
                            error-text="请求失败，点击重新加载"
                            finished-text="没有更多了"
                            @load="getList"
                    >
                        <wy-card v-for="(item, index) in list.data" :key="index" margin="0 0 0.1rem 0">
                            <div class="list-item" @click="detailFn(item)">
                                <van-row class="list-item-top">
                                    <van-col span="18" class="tl">
                                        <div class="item-title">
                      <span class="title-sm">
                        {{item.name}}
                        <van-button
                                size="mini"
                                :type="item.current_status === '已结束'? 'default': 'info'"
                                plain
                                class="btn"
                        >{{item.current_status}}</van-button>
                      </span>
                                        </div>
                                        <div class="item-num" v-if="item.nums">参加企业: 预计{{item.nums}}家,
                                            已参加{{item.approve_count}}家
                                        </div>
                                    </van-col>
                                    <van-col span="6" class="tr item-time" v-if="item.start_time">
                                        <div class="item-hours">{{item.start_time.split(' ')[1]}}</div>
                                        <div class="item-date">{{item.start_time.split(' ')[0]}}</div>
                                    </van-col>
                                </van-row>
                                <van-row class="list-item-bottom">
                                    <van-col span="14" class="tl clearfix">
                                        <van-image width="0.15rem" height="0.15rem"
                                                   :src="item.img+'?x-oss-process=style/w64-h64'" class="fl"/>
                                        <span class="fl item-name"
                                              style="margin-left: 0.05rem;">{{item.organizers}}</span>
                                    </van-col>
                                    <van-col span="10" class="tr item-view">
                                        <span class="iconfont icon-yanjing" style="margin-right: 0.02rem;"></span>
                                        <span>{{item.view_nums}}</span>
                                        <span>已报名{{item.seeker_numbs}}人</span>
                                    </van-col>
                                </van-row>
                                <div class="apply-sign" v-if="myApplyObj[item.video_jobfair_id]">已报名</div>
                            </div>
                        </wy-card>
                    </list>
                </pull-refresh>
            </section>
        </index-bar>
    </div>
</template>

<script>
  import {Swipe, SwipeItem, List, PullRefresh, Field, CellGroup, IndexBar, IndexAnchor} from "vant";
  // import WySelect from "@/components/WySelect";
  import WyCard from "@/components/WyCard";

  import {mapState} from "vuex";

  export default {
    name: "jobfair-list",
    components: {Swipe, SwipeItem, List, PullRefresh, Field, CellGroup, WyCard, IndexBar, IndexAnchor},
    computed: {
      ...mapState({
        route: state => state.route,
        sign: state => state.sign,
        myApplyObj: state => state.myApplyObj
      })
    },
    data() {
      return {
        images: ["/img/banner.png"],
        list: {
          data: [],
          loading: false,
          finished: false,
          error: false,
          params: {
            pageNo: 1,
            pageSize: 15,
            keyword: "",
            city: "",
            organizers: ""
          },
          refreshLoading: false,
          searchLoading: false
        },
        jobfair_name: "",
        SelectList: [{name: "主办方", checked: true}, {name: "城市"}]
      };
    },
    methods: {
      onRefresh() {
        let that = this;

        that.$set(that.list.params, "pageNo", 1);
        that.getList().then(() => {
          setTimeout(() => {
            that.$set(that.list, "refreshLoading", false);
            that.$notify({
              message: "刷新完成",
              type: "primary"
            });
          }, 1000);
        });
      },
      getList() {
        let that = this;

        const {params} = this.list;

        return new Promise(resolve => {
          that.$util
            .get("kzp_video_jobfair", "video_jobfair_list", params)
            .then(res => {
              const {code, msg, data} = res;
              // 加载状态结束
              that.$set(that.list, "loading", false);
              if (code === 1) {
                const {items, total} = data;

                if (params.pageNo === 1) {
                  that.$set(that.list, "finished", false);
                  that.$set(that.list, "data", items);
                } else {
                  that.$set(that.list, "data", [...that.list.data, ...items]);
                }

                // 数据全部加载完成
                if (
                  items.length < params.pagesize ||
                  that.list.data.length >= total
                ) {
                  that.$set(that.list, "finished", true);
                } else {
                  that.$set(that.list.params, "pageNo", params.pageNo + 1);
                }
              } else {
                that.$set(that.list, "error", true);
                that.$notify({
                  message: msg || "获取数据失败，请稍后再试！",
                  type: "danger"
                });
              }

              resolve();
            });
        });
      },
      searchFn() {
        let that = this;
        const {jobfair_name} = that;

        // if (!jobfair_name && ) {
        //   that.$notify({
        //     message: "请输入您要搜索的内容!",
        //     type: "danger"
        //   });
        //   return;
        // }

        if (that.list.searchLoading) {
          that.$notify({
            message: "数据正在查询中,请稍候...",
            type: "warning"
          });
          return;
        }

        that.$set(that.list.params, "pageNo", 1);
        that.$set(that.list.params, "keyword", jobfair_name);

        that.$set(that.list, "searchLoading", true);
        that.getList().then(() => {
          that.$set(that.list, "searchLoading", false);
        });
      },
      detailFn(item) {
        const {video_jobfair_id} = item;

        this.$store.commit("updateJobfairDetail", video_jobfair_id);

        this.$router.push({
          path: "/sub/jobfair-detail?video_jobfair_id=" + video_jobfair_id
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
    .jobfair-list {
        img {
            max-width: 100%;
            max-height: 100%;
        }

        .list {
            padding: 0.15rem;

            .list-item {
                position: relative;
                .apply-sign {
                    position: absolute;
                    right: 0;
                    top: -0.15rem;
                    background-color: #ff7f3e;
                    color: #fff;
                    font-size: 0.12rem;
                    line-height: 0.14rem;
                    padding: 0.02rem 0.06rem;
                    @include box-sizing(border-box);
                    @include border-radius(0 0 0.05rem 0.05rem);
                }
            }

            .list-item-top {
                border-bottom: 1px solid #f3f3f3;
                padding-bottom: 0.1rem;
                .item-title {
                    max-width: 100%;
                    @include box-sizing(border-box);
                    .title-sm {
                        display: inline-block;
                        font-size: 0.14rem;
                        line-height: 0.2rem;
                        position: relative;
                        max-width: 100%;
                        max-height: 0.4rem;
                        padding-right: 0.6rem;
                        @include box-sizing(border-box);
                        > .btn {
                            position: absolute;
                            right: 0;
                            top: 0.02rem;
                        }
                    }
                }

                .item-num {
                    font-size: 0.12rem;
                    line-height: 1.5;
                    color: #999;
                }

                .item-time {
                    padding-top: 0.11rem;
                    color: #3a3a3a;
                    .item-date {
                        line-height: 0.14rem;
                        font-size: 0.12rem;
                    }
                    .item-hours {
                        font-size: 0.14rem;
                        line-height: 0.17rem;
                    }
                }

                span {
                    display: inline-block;
                    overflow: hidden;
                }
            }

            .list-item-bottom {
                padding-top: 0.1rem;
                line-height: 0.15rem;

                .item-name {
                    color: #3a3a3a;
                    font-size: 0.12rem;
                    line-height: 0.16rem;

                    display: inline-block;
                    max-width: calc(100% - 0.2rem);
                    @include over-ellipsis();
                    // @include transform(scale(0.9,0.9));
                }

                .item-view {
                    color: #999;
                    font-size: 0.12rem;
                    line-height: 0.15rem;

                    .iconfont {
                        font-size: 0.12rem;
                        line-height: 0.15rem;
                    }
                }
            }

            .jobfair-img {
                overflow: hidden;
            }
        }
    }
</style>
